import { Theme } from '@mui/material';
import { ThemeMode } from '../types/config';

export const getNightOrDayPalette = (theme: Theme): 'night' | 'day' => (theme.palette.mode === ThemeMode.DARK ? 'night' : 'day');
